// extracted by mini-css-extract-plugin
module.exports = {"container":"Result_container__1MMEc","button":"Result_button__1Trzp"};